export const categories = [
  {
    slug: 'campus',
    name: '校园',
    description: '青春校园里的心动与成长，记录两个女孩在天台、教室与操场之间的相遇与并肩。',
    icon: 'ri-book-2-line',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20webtoon%20illustration%20of%20two%20young%20women%20in%20school%20uniforms%20standing%20on%20a%20sunny%20school%20rooftop%2C%20soft%20warm%20coral%20and%20teal%20color%20palette%2C%20clean%20pastel%20sky%20background%2C%20expressive%20line%20art%2C%20gentle%20afternoon%20light%2C%20harmonious%20composition&width=600&height=400&seq=cat-campus-01&orientation=landscape'
  },
  {
    slug: 'romance',
    name: '恋爱',
    description: '细腻温柔的情感拉扯，从心动到告白，书写只属于她们两个人的浪漫。',
    icon: 'ri-heart-3-line',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20webtoon%20illustration%20of%20two%20young%20women%20holding%20hands%20under%20warm%20fairy%20lights%2C%20soft%20warm%20coral%20and%20teal%20color%20palette%2C%20clean%20pastel%20background%2C%20expressive%20line%20art%2C%20tender%20romantic%20mood%2C%20harmonious%20composition&width=600&height=400&seq=cat-romance-01&orientation=landscape'
  },
  {
    slug: 'fantasy',
    name: '奇幻',
    description: '魔法、剑与异世界，两位女主携手踏上冒险，命运在星光与咒语间交织。',
    icon: 'ri-magic-line',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20webtoon%20illustration%20of%20two%20young%20women%20fantasy%20heroines%20with%20magic%20glow%2C%20soft%20warm%20coral%20and%20teal%20color%20palette%2C%20clean%20pastel%20background%2C%20expressive%20line%20art%2C%20enchanting%20atmosphere%2C%20harmonious%20composition&width=600&height=400&seq=cat-fantasy-01&orientation=landscape'
  },
  {
    slug: 'urban',
    name: '都市',
    description: '霓虹与晚风中的现代都市生活，职场、公寓与深夜街道里悄然生长的关系。',
    icon: 'ri-building-2-line',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20webtoon%20illustration%20of%20two%20young%20women%20in%20stylish%20city%20outfits%20at%20a%20rooftop%20evening%20skyline%2C%20soft%20warm%20coral%20and%20teal%20color%20palette%2C%20clean%20pastel%20background%2C%20expressive%20line%20art%2C%20urban%20evening%20mood%2C%20harmonious%20composition&width=600&height=400&seq=cat-urban-01&orientation=landscape'
  },
  {
    slug: 'healing',
    name: '治愈',
    description: '温暖平静的日常，咖啡香与花店里的小小幸福，抚平疲惫也治愈彼此。',
    icon: 'ri-plant-line',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20webtoon%20illustration%20of%20two%20young%20women%20in%20a%20cozy%20flower%20cafe%2C%20soft%20warm%20coral%20and%20teal%20color%20palette%2C%20clean%20pastel%20background%2C%20expressive%20line%20art%2C%20calm%20cozy%20mood%2C%20harmonious%20composition&width=600&height=400&seq=cat-healing-01&orientation=landscape'
  },
  {
    slug: 'suspense',
    name: '悬疑',
    description: '迷雾重重的谜题与线索，两个女孩并肩追查真相，信任在危机中被反复考验。',
    icon: 'ri-search-eye-line',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20webtoon%20illustration%20of%20two%20young%20women%20detectives%20in%20a%20misty%20street%2C%20soft%20warm%20coral%20and%20teal%20color%20palette%2C%20clean%20muted%20background%2C%20expressive%20line%20art%2C%20mysterious%20mood%2C%20harmonious%20composition&width=600&height=400&seq=cat-suspense-01&orientation=landscape'
  },
  {
    slug: 'history',
    name: '古风',
    description: '长街古巷与月下宫阙，一袭华服、一段旧梦，两个女子的相逢写进时光。',
    icon: 'ri-moon-line',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20webtoon%20illustration%20of%20two%20young%20women%20in%20traditional%20elegant%20robes%20under%20the%20moon%2C%20soft%20warm%20coral%20and%20teal%20color%20palette%2C%20clean%20pastel%20background%2C%20expressive%20line%20art%2C%20classic%20romantic%20mood%2C%20harmonious%20composition&width=600&height=400&seq=cat-history-01&orientation=landscape'
  },
];